"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var colorUtil = require('../../util/color');

var template = require('./palette.jsx');

var displayNames = require('../displayNames');

var _getDistanceToWhite = function getDistanceToWhite(hexColor) {
  return _(hexColor).thru(colorUtil.hexToHsb).thru(colorUtil.getDistanceToWhite).value();
};

var DEFAULT_COLORS = _.unzip([['#FFFFFF', '#D9F0FD', '#ADC6F8', '#C4AEDD', '#E5FAD1'], ['#E8E6E6', '#BEE5FB', '#83A8F0', '#9C7FBA', '#CAE5AF'], ['#C7C7C7', '#7FCCF7', '#155DE9', '#663898', '#9BCB6C'], ['#999997', '#40667C', '#0E3E9B', '#442565', '#4E6636'], ['#414141', '#213D4D', '#071F4E', '#221333', '#27331B']]);

var Palette = /*#__PURE__*/function (_React$Component) {
  _inherits(Palette, _React$Component);

  var _super = _createSuper(Palette);

  function Palette(props) {
    var _this;

    _classCallCheck(this, Palette);

    _this = _super.call(this, props);
    _this.state = {
      colorIndex: _.indexOf(_this.getColorsByPalette(_this.props.palette), _this.props.value)
    };

    _this.onChange = function (color, colorIndex) {
      _this.setState({
        colorIndex: colorIndex
      }, function () {
        _this.props.onChange(color, colorIndex);
      });
    };

    return _this;
  }

  _createClass(Palette, [{
    key: "getDistanceToWhite",
    value: function getDistanceToWhite(hex) {
      return _getDistanceToWhite(hex);
    }
  }, {
    key: "getColorsByPalette",
    value: function getColorsByPalette(palette) {
      return _(palette).unzip().flatten().value();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var palette = this.getColorsByPalette(nextProps.palette);
      var currentColor = palette[this.state.colorIndex];

      if (nextProps.value !== currentColor) {
        this.setState({
          colorIndex: _.indexOf(palette, nextProps.value)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return Palette;
}(React.Component);

Palette.displayName = displayNames.PALETTE;
Palette.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onMainColorChange: PropTypes.func,
  onColorEnter: PropTypes.func,
  onColorLeave: PropTypes.func,
  palette: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  mainColors: PropTypes.arrayOf(PropTypes.string)
};
Palette.defaultProps = {
  palette: DEFAULT_COLORS,
  onColorEnter: _.noop,
  onColorLeave: _.noop,
  onChange: _.noop,
  onMainColorChange: _.noop
};
module.exports = compose(Palette);